<template>
  <div>
    <router-link to="/admin">
      <md-card md-with-hover>
        <md-ripple>
            <md-card-area>
              <md-card-header>
                <md-icon class="md-size-5x" style="margin-top:20px; margin-bottom: 108px">settings</md-icon>
                <br/>
                <span class="md-title">Admin</span>
              </md-card-header>
            </md-card-area>
        </md-ripple>
      </md-card>
    </router-link>

    <router-link :to="'/city/' + city.abbreviation" v-for="city in cities" :key="city.versionedId.id">
      <md-card md-with-hover>
        <md-ripple>
          <md-card-media-cover md-text-scrim v-if="city.cardImageId !== undefined">
            <md-card-media md-ratio="1:1">
              <img :src="'/api/file/' + city.cardImageId.id + ''" :alt="city.name" v-if="city.cardImageId !== undefined">
            </md-card-media>

            <md-card-area >
              <md-card-header>
                <span class="md-title">{{city.name}}</span>
              </md-card-header>
            </md-card-area>
          </md-card-media-cover>
          <md-card-area v-if="city.cardImageId === undefined">
            <md-card-header>
              <md-icon class="md-size-5x" style="margin-top:20px; margin-bottom: 108px">location_city</md-icon>
              <br/>
              <span class="md-title">{{city.name}}</span>
            </md-card-header>
          </md-card-area>
        </md-ripple>
      </md-card>
    </router-link>

  </div>
</template>

<script>
  export default {
    name: "main-vue",
    computed: {
      cities() {
        return this.$store.state.cities
      }
    }
  }
</script>

<style scoped>
  .md-card {
    width: 320px;
    height: 320px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/components/MainVue.vue